// extracted by mini-css-extract-plugin
module.exports = {"mainArea":"direct_mainArea__Xh3yd","body":"direct_body__3ucOY","wrapper":"direct_wrapper__ftEUv","dateGroup":"direct_dateGroup__1YTIa"};